"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _themeGet = require("@styled-system/theme-get");

var _pclnDesignSystem = require("pcln-design-system");

var _TabHeader = _interopRequireDefault(require("./TabHeader"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TabsContainer = _styledComponents["default"].div.withConfig({
  componentId: "sc-121j268-0"
})(["display:flex;flex-direction:column;width:100%;"]);

var TabHeaders = _styledComponents["default"].div.withConfig({
  componentId: "sc-121j268-1"
})(["display:flex;justify-content:flex-start;border-bottom:1px solid ", ";"], (0, _pclnDesignSystem.getPaletteColor)('border.base'));

var TabContents = _styledComponents["default"].div.withConfig({
  componentId: "sc-121j268-2"
})(["display:flex;padding:", "px ", "px;"], (0, _themeGet.themeGet)('space.4'), (0, _themeGet.themeGet)('space.2'));

var Tabs = /*#__PURE__*/function (_PureComponent) {
  _inherits(Tabs, _PureComponent);

  function Tabs() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Tabs);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Tabs)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      currentTabIndex: 0
    });

    _defineProperty(_assertThisInitialized(_this), "handleTabClick", function (index) {
      _this.setState({
        currentTabIndex: index
      });
    });

    return _this;
  }

  _createClass(Tabs, [{
    key: "renderTabHeaders",
    value: function renderTabHeaders() {
      var _this2 = this;

      var titles = this.props.tabs.map(function (tab) {
        return tab.title;
      });
      return titles.length > 1 ? _react["default"].createElement(TabHeaders, null, titles.map(function (title, index) {
        return _react["default"].createElement(_TabHeader["default"], {
          key: index,
          index: index,
          title: title,
          isActive: _this2.state.currentTabIndex === index,
          activeColor: _this2.props.activeTabColor,
          onClick: _this2.handleTabClick,
          backgroundColor: _this2.props.backgroundColor,
          boxShadowColor: _this2.props.boxShadowColor
        });
      })) : null;
    }
  }, {
    key: "renderTabContent",
    value: function renderTabContent() {
      var contents = this.props.tabs.length > this.state.currentTabIndex ? this.props.tabs[this.state.currentTabIndex].content : null;
      return _react["default"].createElement(TabContents, null, contents);
    }
  }, {
    key: "render",
    value: function render() {
      return _react["default"].createElement(TabsContainer, null, this.renderTabHeaders(), this.renderTabContent());
    }
  }]);

  return Tabs;
}(_react.PureComponent);

Tabs.displayName = 'Tabs';
Tabs.propTypes = {
  activeTabColor: _propTypes["default"].string,
  tabs: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    title: _propTypes["default"].node,
    content: _propTypes["default"].node
  })),
  backgroundColor: _propTypes["default"].string,
  boxShadowColor: _propTypes["default"].string
};
Tabs.defaultProps = {
  tabs: []
};
var _default = Tabs;
exports["default"] = _default;